import api from './api';

// `params` exists for the row cap: the endpoint defaults to limit=500, and the finance
// page's previous-year comparison needs more.
export const getAllInvoices = (params) => api.get('/Invoice', { params }).then(r => r.data);
export const createInvoice = (dto) => api.post('/Invoice', dto).then(r => r.data);
export const updateInvoice = (id, dto) => api.patch(`/Invoice/${id}`, dto).then(r => r.data);
export const deleteInvoice = (id) => api.delete(`/Invoice/${id}`).then(r => r.data);
export const downloadInvoicePdf = (id) =>
    api.get(`/Invoice/${id}/pdf`, { responseType: 'blob' }).then(r => r.data);
// With the id of a saved document, the preview carries its stored attachments as well.
export const previewInvoicePdf = (dto, invoiceId) =>
    api.post('/Invoice/preview-pdf', dto, {
        responseType: 'blob',
        params: invoiceId ? { invoice_id: invoiceId } : undefined,
    }).then(r => r.data);

// PDFs appended behind an invoice's or an offer's own pages. Every call but `file` returns the
// full list, so the caller never has to merge its own state back in.
const attachmentCalls = (resource) => ({
    list: (id) => api.get(`/${resource}/${id}/attachments`).then(r => r.data),
    upload: (id, file) => {
        const data = new FormData();
        data.append('file', file);
        return api
            .post(`/${resource}/${id}/attachments`, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then(r => r.data);
    },
    reorder: (id, order) => api.patch(`/${resource}/${id}/attachments`, { order }).then(r => r.data),
    remove: (id, annexId) => api.delete(`/${resource}/${id}/attachments/${annexId}`).then(r => r.data),
    // Through the API, not a presigned URL: a tab cannot send the X-API-Key header.
    file: (id, annexId) =>
        api.get(`/${resource}/${id}/attachments/${annexId}/file`, { responseType: 'blob' })
            .then(r => r.data),
});

export const {
    list: getInvoiceAttachments,
    upload: uploadInvoiceAttachment,
    reorder: reorderInvoiceAttachments,
    remove: deleteInvoiceAttachment,
    file: getInvoiceAttachmentFile,
} = attachmentCalls('Invoice');

export const {
    list: getOfferAttachments,
    upload: uploadOfferAttachment,
    reorder: reorderOfferAttachments,
    remove: deleteOfferAttachment,
    file: getOfferAttachmentFile,
} = attachmentCalls('Offer');

export const getAllOffers = () => api.get('/Offer').then(r => r.data);
export const createOffer = (dto) => api.post('/Offer', dto).then(r => r.data);
export const updateOffer = (id, dto) => api.patch(`/Offer/${id}`, dto).then(r => r.data);
export const deleteOffer = (id) => api.delete(`/Offer/${id}`).then(r => r.data);
export const downloadOfferPdf = (id) =>
    api.get(`/Offer/${id}/pdf`, { responseType: 'blob' }).then(r => r.data);
export const previewOfferPdf = (dto, offerId) =>
    api.post('/Offer/preview-pdf', dto, {
        responseType: 'blob',
        params: offerId ? { offer_id: offerId } : undefined,
    }).then(r => r.data);

/** Convert an accepted offer. Only project_id is required; anything left out the backend derives
 *  from the offer, and converting also accepts it. → { status, order_id, order_number } */
export const convertOfferToOrder = (offerId, dto) =>
    api.post(`/Offer/${offerId}/convert`, dto).then(r => r.data);
